import { CloseIcon, Color } from "@bonliva-crm/ui";
import {
  Box,
  IconButton,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps
} from "@material-ui/core";
import * as React from "react";
import { useState } from "react";

export const TextField = React.forwardRef<
  HTMLInputElement,
  MuiTextFieldProps & {
    showWordCount?: boolean;
    onClear?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    isClearable?: boolean;
  }
>((props, ref) => {
  const {
    showWordCount = false,
    helperText,
    value,
    onChange,
    isClearable,
    onClear,
    ...other
  } = props;
  const [val, setVal] = useState("");

  const _value = value ?? val;
  const _onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (onChange) {
      onChange(e);
    } else {
      setVal(e.target.value);
    }
  };

  if (showWordCount && !props.inputProps?.maxLength) {
    throw new Error("showWordCount needs maxLength to be set on inputProps");
  }

  return (
    <MuiTextField
      ref={ref}
      onChange={_onChange}
      {...other}
      InputProps={{
        ...(props.InputProps || {}),
        endAdornment: (
          <>
            {isClearable && onClear && _value ? (
              <IconButton
                style={{ padding: 0, width: "1rem", height: "1rem" }}
                onClick={onClear}
              >
                <CloseIcon
                  htmlColor={Color.Body}
                  style={{ width: "16px", height: "16px" }}
                />
              </IconButton>
            ) : undefined}
            {props.InputProps?.endAdornment}
          </>
        )
      }}
      value={_value}
      helperText={
        <Box
          component="span"
          style={{
            display: "flex",
            justifyContent: "space-between",
            gridGap: "0.5rem"
          }}
        >
          <span>{helperText}</span>
          {showWordCount && (
            <span>{`${((_value as string) ?? "").length} / ${
              props.inputProps?.maxLength
            }`}</span>
          )}
        </Box>
      }
    />
  );
});

TextField.displayName = "TextField";

export default TextField;
